jQuery(document).ready(function ($) {

    if (typeof productReplaced !== 'undefined' && productReplaced) {

        let productReplacedAlert = $('<div class="checkout-info-card" style="background: rgba(245, 158, 11, 0.06); border-color: rgba(245, 158, 11, 0.15);"><i class="fa-solid fa-circle-info" style="color: #f59e0b;"></i><span>The trial period is not available because you have already purchased a product.</span></div>');

        // Add after .sidebar-price-breakdown
        $(".sidebar-price-breakdown").after(productReplacedAlert.clone());
    }

    // Sidebar coupon toggle
    $(document.body).on('click', '#sidebar-coupon-toggle', function(e) {
        e.preventDefault();
        $('#sidebar-coupon-form').slideToggle(200);
    });

    $(document.body).on('click', '#sidebar-apply-coupon', function() {
        var code = $('#sidebar-coupon-code').val();
        if (!code) return;

        var $button = $(this);
        $button.prop('disabled', true).text('Applying...');

        var ajaxUrl = (typeof wc_checkout_params !== 'undefined' && wc_checkout_params.wc_ajax_url)
            ? wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'apply_coupon')
            : '/?wc-ajax=apply_coupon';

        var nonce = (typeof wc_checkout_params !== 'undefined' && wc_checkout_params.apply_coupon_nonce)
            ? wc_checkout_params.apply_coupon_nonce
            : '';

        $.ajax({
            type: 'POST',
            url: ajaxUrl,
            data: {
                security: nonce,
                coupon_code: code
            },
            dataType: 'html',
            success: function(response) {
                $('.woocommerce-error, .woocommerce-message, .woocommerce-info').remove();
                if (response) {
                    var $notices = $('.woocommerce-notices-wrapper').first();
                    if ($notices.length) {
                        $notices.html(response);
                    } else {
                        $('form.checkout').before(response);
                    }
                }
                $(document.body).trigger('applied_coupon', [code]);
                $('body').trigger('update_checkout');
                $button.prop('disabled', false).text('Apply');
                $('#sidebar-coupon-code').val('');
            },
            error: function() {
                $button.prop('disabled', false).text('Apply');
            }
        });
    });

    // EU VAT territory: the same 27 member states as ddb_vat_member_states() in PHP.
    function is_eu_country(country_code) {
        return ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'].includes(country_code);
    }

    function get_country_vat(country_code) {

        // If the country code is not in the list, return "Sales Tax" as a default
        if (!countryVAT.hasOwnProperty(country_code)) {
            return countryVAT['US'];
        }
        return countryVAT[country_code];
    }

    const countryVAT = {
        AT: "USt",
        BE: "BTW",
        BG: "DDS",
        CY: "FPA",
        CZ: "DPH",
        DE: "MwSt",
        DK: "MOMS",
        EE: "KM",
        EL: "FPA",
        ES: "IVA",
        FI: "ALV",
        FR: "TVA",
        HR: "PDV",
        HU: "ÁFA",
        IE: "VAT",
        IT: "IVA",
        LT: "PVM",
        LU: "TVA",
        LV: "PVN",
        MT: "VAT",
        NL: "BTW",
        PL: "PTU",
        PT: "IVA",
        RO: "TVA",
        SE: "MOMS",
        SI: "DDV",
        SK: "DPH",
        UK: "VAT",
        US: "Sales Tax" // Note: In the USA, VAT is not common; instead, it's sales tax
    };

    // Mirrors ddb_vat_vat_id_parts() in code/tax/vat-rules.php; the server stays authoritative.
    // Bodies here are matched against the VAT id with its country prefix removed.
    const vatIdPatterns = {
        AT: /^U[A-Z\d]{8}$/, BE: /^0\d{9}$/, BG: /^\d{9,10}$/, CY: /^\d{8}[A-Z]$/,
        CZ: /^\d{8,10}$/, DE: /^\d{9}$/, DK: /^(\d{2} ?){3}\d{2}$/, EE: /^\d{9}$/,
        EL: /^\d{9}$/, ES: /^([A-Z]\d{7}[A-Z]|\d{8}[A-Z]|[A-Z]\d{8})$/, FI: /^\d{8}$/,
        FR: /^([A-Z]{2}|[A-Z0-9]{2})\d{9}$/, HR: /^\d{11}$/, HU: /^\d{8}$/,
        IE: /^[A-Z\d]{8,10}$/, IT: /^\d{11}$/, LT: /^(\d{9}|\d{12})$/, LU: /^\d{8}$/,
        LV: /^\d{11}$/, MT: /^\d{8}$/, NL: /^\d{9}B\d{2}$/, PL: /^\d{10}$/,
        PT: /^\d{9}$/, RO: /^\d{2,10}$/, SE: /^\d{12}$/, SI: /^\d{8}$/, SK: /^\d{10}$/,
    };

    // The VAT prefix a country issues under: Greece is EL, Monaco is handled as France.
    function vatIdPrefix(country) {
        if (country === 'GR') return 'EL';
        if (country === 'MC') return 'FR';
        return country;
    }

    function prefixCountry(prefix) {
        return prefix === 'EL' ? 'GR' : prefix;
    }

    // Country names come from the billing selector, so they stay localized.
    function countryName(code) {
        return $('#billing_country option[value="' + code + '"]').text().trim() || code;
    }

    function checkVatId(country, value) {
        const expected = vatIdPrefix(country);
        const clean = (value || '').toUpperCase().replace(/[\s.,-]/g, '');

        if (!clean) return { status: 'empty', expected: expected, attempted: '' };
        if (!vatIdPatterns[expected]) return { status: 'unsupported', expected: expected, attempted: clean.substring(0, 2) };

        const head = clean.substring(0, 2);
        let body = clean;

        if (head === expected) {
            body = clean.substring(2);
        } else if (vatIdPatterns[head] || is_eu_country(head)) {
            return { status: 'mismatch', expected: expected, attempted: head };
        }

        return { status: vatIdPatterns[expected].test(body) ? 'ok' : 'format', expected: expected, attempted: head };
    }

    function vatIdErrorMessage(result) {
        const expectedName = countryName(result.expected);

        if (result.status === 'empty') {
            return 'A VAT number issued in ' + expectedName + ' is required for company invoicing.';
        }

        if (result.status === 'mismatch') {
            return 'The VAT number starts with ' + result.attempted + ', the prefix used in '
                + countryName(prefixCountry(result.attempted)) + '. Invoicing in ' + expectedName
                + ' requires a VAT number issued there, which starts with ' + result.expected + '.';
        }

        if (result.status === 'format') {
            return 'That is not a valid VAT number format for ' + expectedName
                + '. VAT numbers issued there start with ' + result.expected + '.';
        }

        return '';
    }

    // The "I'm a company" tick is what puts the reverse charge on the table, so the id is
    // only demanded while it is on. VIES itself cannot be asked here: the price breakdown
    // showing VAT is the answer to that.
    // A field the customer has not used yet is not reported: an empty VAT number turns red
    // only once it has been left, or after a refused submit, not as soon as the company
    // switch shows it. A prefilled value is checked straight away.
    let vatIdTouched = false;

    // Bound on the field itself, before the blur handler that renders the message below,
    // so the first blur already counts.
    $('#billing_vat_number').on('blur', function () {
        vatIdTouched = true;
    });

    $(document.body).on('checkout_error', function () {
        vatIdTouched = true;
        renderVatIdError();
    });

    function renderVatIdError() {
        const $field = $('#billing_vat_number_field');

        if (!$field.length) return;

        const country = $('#billing_country').val();
        const pristine = !vatIdTouched && !$('#billing_vat_number').val();
        let message = '';

        if (!pristine && $('#is_company').is(':checked') && is_eu_country(country)) {
            const result = checkVatId(country, $('#billing_vat_number').val());

            if (result.status !== 'ok' && result.status !== 'unsupported') {
                message = vatIdErrorMessage(result);
            }
        }

        $field.find('.checkout-inline-error-message').remove();

        if (message) {
            $('#billing_vat_number').attr('aria-invalid', 'true');
            $field.removeClass('woocommerce-validated').addClass('woocommerce-invalid');
            $('<p class="checkout-inline-error-message"></p>').text(message).insertAfter($('#billing_vat_number'));
        } else {
            $('#billing_vat_number').removeAttr('aria-invalid');
            $field.removeClass('woocommerce-invalid').addClass('woocommerce-validated');
        }
    }

    // Mirrors ddb_checkout_uncollected_address_fields() in code/checkout-rules.php: a private
    // buyer gives no street, city or state, and a postcode only where card issuers check it.
    // The classes drive the stylesheet; WooCommerce's own locale script keeps setting which
    // of the visible fields are required, and the server drops what is not collected.
    function applyAddressRules() {
        const company = $('#is_company').is(':checked');
        const postcodeCountries = typeof ddbCheckout !== 'undefined' ? ddbCheckout.postcodeCountries : [];
        const needsPostcode = company || postcodeCountries.indexOf($('#billing_country').val()) !== -1;

        $('form.checkout')
            .toggleClass('ddb-is-company', company)
            .toggleClass('ddb-needs-postcode', needsPostcode);
    }

    applyAddressRules();

    // Mirrors ddb_username_is_valid() in code/checkout-rules.php; the server stays authoritative.
    // main.js already lowers and strips the username while it is typed, so what is left
    // to report here is mostly the length.
    function isValidUsername(value) {
        return value.length >= 2 && value.length <= 128
            && /^[a-z0-9][a-z0-9_-]*$/.test(value) && value.indexOf('--') === -1;
    }

    function renderUsernameError() {
        const $input = $('#account_username');
        const $field = $('#account_username_field');
        const value = $input.val() || '';
        const invalid = value !== '' && !isValidUsername(value);

        $field.find('.checkout-inline-error-message').remove();
        $input.attr('aria-invalid', invalid ? 'true' : null);
        $field.toggleClass('woocommerce-invalid', invalid);

        if (invalid && typeof ddbCheckout !== 'undefined') {
            $('<p class="checkout-inline-error-message"></p>').text(ddbCheckout.usernameRule).insertAfter($input);
        }
    }

    // Clear the message as soon as the value is fixed, without nagging while it is first typed.
    $(document.body).on('input', '#account_username', function () {
        if ($('#account_username_field .checkout-inline-error-message').length) {
            renderUsernameError();
        }
    });

    $(document.body).on('blur', '#account_username', renderUsernameError);

    // The VAT line of the order summary carries the explainer that used to sit under the
    // billing fields. WooCommerce repaints that block on every update_checkout, which
    // replaces the icon with a brand new node, so the popover is bound to whatever is on
    // the page each time the summary settles. Bootstrap ships with the theme; without it
    // the icon is simply inert, so no VAT rule depends on the script.
    let vatInfoBound = [];

    function initVatPopovers() {
        if (typeof bootstrap === 'undefined' || !bootstrap.Popover) {
            return;
        }

        // A refresh that swaps the summary takes the trigger away while its bubble may be
        // open, and the hide event that would have closed it belongs to a node nobody can
        // reach any more. Disposing those bindings closes the stale bubble and keeps
        // Bootstrap from holding onto the detached summary.
        vatInfoBound = vatInfoBound.filter(function (el) {
            if (el.isConnected) {
                return true;
            }
            const instance = bootstrap.Popover.getInstance(el);
            if (instance) {
                instance.dispose();
            }
            return false;
        });

        document.querySelectorAll('.ddb-vat-info').forEach(function (el) {
            if (bootstrap.Popover.getInstance(el)) {
                return;
            }

            // The icon sits at the left edge of the summary, so the bubble is pushed right
            // to land over the sidebar rather than over the billing fields.
            new bootstrap.Popover(el, { container: 'body', offset: [90, 8] });
            vatInfoBound.push(el);
        });
    }

    $(document.body).on('updated_checkout', function(e, data) {

        console.log('updated_checkout', e, data);

        state.isUpdatingCheckout = false;

        // Re-apply toggle logic after checkout update
        toggleCompanyVatFields();
        renderVatIdError();
        initVatPopovers();
    });


    let reqElement = $('<abbr class="required" title="required">*</abbr>');
    let optElement = $('<span class="optional">(optional)</span>');

    // Function to toggle the Company and VAT number fields
    function toggleCompanyVatFields() {
        if ($('#is_company').is(':checked')) {

            let country = $('#billing_country').val();

            $('#billing_company_field, #billing_vat_number_field').show();

            setRequired('billing_company', true);
            setRequired('billing_vat_number', is_eu_country(country));
        } else {
            $('#billing_company_field, #billing_vat_number_field').hide();
            setRequired('billing_company', false);
            setRequired('billing_vat_number', false);
        }
    }

    function setRequired(field, required) {

        let idSel = "#" + field;

        let isRequired = $(idSel + "_field").hasClass('validate-required');

        if (required && !isRequired) {

            $(idSel + "_field").addClass('validate-required');

            $(idSel + "_field > label > span").remove();
            $(idSel + "_field > label").append(reqElement.clone());

        } else if (!required && isRequired) {

            $(idSel + "_field").removeClass('validate-required');

            $(idSel + "_field > label > .required").remove();
            $(idSel + "_field > label").append(optElement.clone());
        }
    }

    // Set required fields
    setRequired('billing_company', true);
    setRequired('billing_vat_number', true);


    // Initial call
    toggleCompanyVatFields();
    initVatPopovers();

    state = {
        billing_company: null,
        billing_vat_number: null,
        isUpdatingCheckout: false
    }

    // Toggle on click (more reliable than change for checkboxes)
    $(document.body).on('click', '#is_company', function () {
        toggleCompanyVatFields();
        applyAddressRules();
        renderVatIdError();
        console.log('is_company click, trigger update_checkout');

        if (!state.isUpdatingCheckout) {
            state.isUpdatingCheckout = true;
            $('body').trigger('update_checkout');
        }

    });


    $('#billing_company, #billing_vat_number').on('blur', function (e) {
        //console.log('fields blur, trigger update_checkout', e);

        renderVatIdError();

        if (state.billing_company !== $('#billing_company').val() ||
            state.billing_vat_number !== $('#billing_vat_number').val()) {
            if (!state.isUpdatingCheckout) {
                state.isUpdatingCheckout = true;
                $('body').trigger('update_checkout');
            }
        }

        state.billing_company = $('#billing_company').val();
        state.billing_vat_number = $('#billing_vat_number').val();

    });

    // Toggle on country change
    $(document.body).on('change', '#billing_country', function () {
        applyAddressRules();
        toggleCompanyVatFields();
        renderVatIdError();
        console.log('country change, trigger update_checkout');

        if (!state.isUpdatingCheckout) {
            state.isUpdatingCheckout = true;
            $('body').trigger('update_checkout');
        }
    });

    // Trigger $('body').trigger('update_checkout') on coupon apply
    $(document.body).on('applied_coupon', function () {
        console.log('applied_coupon, trigger update_checkout');
        if (!state.isUpdatingCheckout) {
            state.isUpdatingCheckout = true;
            $('body').trigger('update_checkout');
        }
    });

    // Trigger the change event when quantity input changes
    $('body').on('change', 'input.qty', function() {
        var qtyField = $(this);
        var cart_item_key = qtyField.closest('tr').find('input.qty').attr('name').match(/\[(.*?)\]/)[1];
        var new_qty = qtyField.val();

        // Show the loading spinner while the checkout updates
        $('body').trigger('update_checkout');

        // Perform the AJAX request to update the cart
        $.ajax({
            type: 'POST',
            url: pageInfo.ajaxUrl,
            data: {
                action: 'update_cart_quantity',
                cart_item_key: cart_item_key,
                quantity: new_qty,
            },
            success: function(response) {
                // Reload the checkout fragments to update the totals and review section
                $('body').trigger('update_checkout');
            },
            error: function() {
                console.log('Error updating cart quantity');
            }
        });
    });

});
